import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const OccupantNameDropdown = (props) => {
  const {
    onChange,
    defaultValue,
    name,
    nameOption,
    disabledDropdown = false,
  } = props;

  console.log(disabledDropdown, defaultValue, "disabledDropdown");

  const handleDropdownChange = (value) => {
    const selectedOption = nameOption.find((option) => option.id == value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue} // Default to first option if no defaultValue
      placeholder="Select by occupant name"
      options={nameOption}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabledDropdown={disabledDropdown}
      width="220px"
      disabled={true}
    />
  );
};

export default OccupantNameDropdown;
